import { ElementRef } from '@angular/core';

export function isElementHasChildren(element: ElementRef): boolean {
    return element && element.nativeElement && element.nativeElement.childNodes.length > 0;
}

export function isOverflowing(element) {
  return (element.scrollWidth > element.offsetWidth);
}
